import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { cn } from '@/lib/utils';
interface ClickableTagsProps {
  /** Array of tag strings to display */
  tags: string[];
  /**
   * Function to build the href for each tag.
   * Receives the tag value and should return the full path with query param.
   * @example (tag) => `/content?tags=${encodeURIComponent(tag)}`
   */
  getHref: (tag: string) => string;
  /** Optional className for the outer wrapper */
  className?: string;
  /** Optional className for each tag link */
  tagClassName?: string;
}

/**
 * Reusable clickable tags component. Renders tags as Next.js Links
 * that navigate to a filterable page with the tag as a query parameter.
 */
export function ClickableTags(t0) {
  const $ = _c(12);
  const {
    tags,
    getHref,
    className,
    tagClassName
  } = t0;
  if (!tags || tags.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-wrap gap-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getHref || $[3] !== tagClassName || $[4] !== tags) {
    let t3;
    if ($[6] !== getHref || $[7] !== tagClassName) {
      t3 = tag => <Link key={tag} href={getHref(tag)} className={cn("bg-white border border-gray-200 text-gray-600 text-[11px] px-2.5 py-1 rounded-md cursor-pointer hover:bg-gray-100 hover:border-gray-300 transition-colors", tagClassName)}>{tag}</Link>;
      $[6] = getHref;
      $[7] = tagClassName;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tags.map(t3);
    $[2] = getHref;
    $[3] = tagClassName;
    $[4] = tags;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}